<template>
	<div></div>
</template>
 
<script>
import wx from 'weixin-js-sdk'

export default {
	name: 'login',
	data() {
		return {
			code:''
		}
	},
	mounted() {
			 var url =  window.location.href
             var code = url.split('&')[0].split('?')[1].split('code=')[1]
		     wx.miniProgram.navigateTo({url: '/pages/property/login/login?code=' + code})

		//跳转回小程序的登录页面并将公众号openid带过去
	},
}
</script>